import React, { useEffect, useState } from "react";
import ReactAnimatedWeather from "react-animated-weather";
// import { useGlobalWeather } from "./Stores";

export default function Temperature(props) {
  const data = props.data;
  var celsiusTemperature = Math.round(data.temp);
  var fahrenheitTemperature = Math.round((celsiusTemperature * 9) / 5 + 32);
  var [temp, setTemp] = useState(celsiusTemperature);
  // const { globalWeather, setGlobalWeather } = useGlobalWeather();
  // console.log(globalWeather);

  useEffect(() => {
    setTemp(celsiusTemperature);
  }, [celsiusTemperature]);

  var [isCelsuis, setIsCelsius] = useState(true);
  var [isFahrenheit, setIsFahrenheit] = useState(false);
  const codeMapping = {
    "01d": "CLEAR_DAY",
    "01n": "CLEAR_NIGHT",
    "02d": "PARTLY_CLOUDY_DAY",
    "02n": "PARTLY_CLOUDY_NIGHT",
    "03d": "PARTLY_CLOUDY_DAY",
    "03n": "PARTLY_CLOUDY_NIGHT",
    "04d": "CLOUDY",
    "04n": "CLOUDY",
    "09d": "RAIN",
    "09n": "RAIN",
    "10d": "RAIN",
    "10n": "RAIN",
    "11d": "RAIN",
    "11n": "RAIN",
    "13d": "SNOW",
    "13n": "SNOW",
    "50d": "FOG",
    "50n": "FOG",
  };

  function setCelsius(event) {
    event.preventDefault();
    setIsFahrenheit(false);
    setIsCelsius(true);
    setTemp(celsiusTemperature);
  }
  function setFahrenheit(event) {
    // event.preventDefault();
    event.preventDefault();
    setIsFahrenheit(true);
    setIsCelsius(false);
    setTemp(fahrenheitTemperature);
  }
  return (
    <section className="temperature mt-5 mb-5 ">
      <span className="pt-3 mt-3 pe-1">
        <ReactAnimatedWeather
          icon={codeMapping[data.icon]}
          color={"black"}
          size={50}
          animate={true}
        />
      </span>
      <span className="mt-2 pt-1">
        <span id="temperature-value">{temp}</span>
        <span id="units" className="ms-1">
          <span>
            <a
              className={`text-decoration-none ${
                isCelsuis ? "inactive-link" : "none"
              }`}
              id="celsius-unit"
              href="/"
              onClick={setCelsius}
            >
              °C
            </a>
          </span>
          <span>
            |
            <a
              className={`text-decoration-none ${
                isFahrenheit ? "inactive-link" : "none"
              }`}
              id="farenheit-unit"
              href="/"
              onClick={setFahrenheit}
            >
              °F
            </a>
          </span>
        </span>
      </span>
    </section>
  );
}
